import React, { createContext, useState, useMemo } from 'react';
import { api } from '../middlewares';
import ApiViaCep from '../middlewares/correiosApi';

const ContextGetMeuPerfil = createContext();

function GetMeuPerfil({ children }) {
  const [loadingMeuPerfil, setLoadingMeuPerfil] = useState(true);
  const [perfil, setPerfil] = useState({});
  async function importDataMeuPerfil() {
    let result = '';
    try {
      result = await api.get('Perfil/GetPerfil');
      setLoadingMeuPerfil(false);
      setPerfil(result.data);
      return result.data;
    } catch (error) {
      return error;
    }
  }

  async function getEnderecoPorCep(cep) {
    let resultGetEndereco = '';
    try {
      resultGetEndereco = await ApiViaCep.get(`${cep}/json/`);
      return resultGetEndereco.data;
    } catch (error) {
      return [];
    }
  }

  const updatePerfil = async (dados) => {
    try {
      const result = await api.put('Perfil/EditPerfil', dados);
      return result;
    } catch (error) {
      return error.request;
    }
  };

  const changeEmail = async (email, cpf) => {
    try {
      const resultChangeEmail = await api.put('Perfil/EditEmail', email, {
        params: { cpf: cpf },
      });
      return resultChangeEmail;
    } catch (error) {
      return error;
    }
  };

  const updateImage = async (url_image) => {
    try {
      const result = await api
        .put('Perfil/EditImagemPerfil', {
          url_image,
        })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });

      return result;
    } catch (error) {
      return error;
    }
  };

  const values = useMemo(() => {
    return {
      importDataMeuPerfil,
      updatePerfil,
      updateImage,
      loadingMeuPerfil,
      changeEmail,
      getEnderecoPorCep,
      perfil,
    };
  }, [
    importDataMeuPerfil,
    updatePerfil,
    updateImage,
    loadingMeuPerfil,
    changeEmail,
    getEnderecoPorCep,
    perfil,
  ]);

  return (
    <ContextGetMeuPerfil.Provider value={values}>
      {children}
    </ContextGetMeuPerfil.Provider>
  );
}

export { GetMeuPerfil, ContextGetMeuPerfil };
